<template>
  <el-button
    icon="el-icon-plus"
    type="primary"
    size="small"
    @click="add"
  >
    Добавить
  </el-button>
</template>

<script>
export default {
  name: 'UiAddButton',
  props: {
    href: {
      type: String,
      required: true,
    },
  },
  methods: {
    add() {
      this.$inertia.visit(this.href);
    },
  },
};
</script>
